// extracted by mini-css-extract-plugin
export default {"container":"ReviewCampaignList_container__E0l8U"};